<template>
  <div
    class="tw-flex tw-flex-wrap tw-items-center md:tw-items-end tw-justify-between tw-gap-[16px] tw-ps-[22px] md:tw-ps-[46px] md:tw-pe-[40px]"
  >
    <h1
      class="tw-mb-0 tw-text-[var(--my-white-soft2)] md:tw-text-[var(--my-primary)] tw-text-[25px] md:tw-text-[35px] tw-leading-[1.2] tw-font-black"
    >
      {{ $t("dashboard.my_contacts_title", "Team Management") }}
    </h1>

    <div class="tw-flex tw-gap-[16px]">
      <my-btn
        :disabled="isLoading"
        btnStyle="my-primary my-primary--mobile-dark-bg"
        @click="() => this.$root.$emit('bv::show::modal', 'my-add-contact-popup')"
      >
        <span class="tw-hidden md:tw-block">{{
          $t("donor_dashboard.my_contacts_btn_add_new_contact", "Add New Contact")
        }}</span>
        <span class="tw-block md:tw-hidden">{{
          $t("donor_dashboard.my_contacts_btn_add_contact", "Add Contact")
        }}</span>
      </my-btn>
      <my-btn
        :disabled="isLoading"
        btnStyle="my-primary my-primary--mobile-dark-bg"
        @click="() => this.$root.$emit('bv::show::modal', 'my-import-contacts-popup')"
      >
        <span class="tw-hidden md:tw-block">{{
          $t("donor_dashboard.my_contacts_btn_import_contacts", "Import Contacts")
        }}</span>
        <span class="tw-block md:tw-hidden">{{
          $t("donor_dashboard.my_contacts_btn_import", "Import")
        }}</span>
      </my-btn>
    </div>
  </div>
</template>

<script>
import myBtn from "@/views/donor-dashboard/my-contacts/ui/my-btn.vue";

export default {
  name: "contact-list-header",

  props: {
    isLoading: {
      type: Boolean,
      default: false,
    },
  },

  components: {
    myBtn,
  },
};
</script>
